import styled from 'styled-components';
import {themeProvider} from '@swipejobs/frontend-theme-provider';

export const Title = styled.div`
  margin-bottom: 16px;
  font-weight: bold;
  font-size: large;
`;

export const SeeInstructions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 16px;
  font-weight: bold;
  color: ${() => themeProvider.getColors().general.primaryColor};
  text-decoration: none;
  cursor: pointer;
`;

export const HighlightedCaption = styled.div`
  white-space: normal;
  font-weight: bold;
  color: ${() => themeProvider.getColors().general.primaryColor};
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/styles.tsx